import { useRef, useEffect } from "react";
import { If } from "react-conditional-components-renderer";

import { useOutsideClick } from "@ascendnow/shared";

import AscAdminAction, {
  AscAdminActionOptionProps,
} from "../AscAdminAction/AscAdminAction";
import { MoreIcon } from "../AscIcons";
import styles from "./AscTableResponsive.module.scss";
import AscPortal from "../AscPortal/AscPortal";

const contentVerticalOffset = 40;
const contentHorizontalOffset = 7;

interface IProps {
  actions: AscAdminActionOptionProps[];
}

export function AscTableActions({ actions }: IProps) {
  const {
    ref: containerRef,
    isVisible,
    setIsVisible,
  } = useOutsideClick<HTMLDivElement>(false, false);

  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.style.visibility = `hidden`;
    }

    const containerRect = containerRef?.current?.getBoundingClientRect();
    const contentContainerRect = contentRef?.current?.getBoundingClientRect();

    if (!containerRect || !contentContainerRect) {
      return;
    }

    const left =
      containerRect.left - contentContainerRect.width - contentHorizontalOffset;
    const top = containerRect.y + containerRect.height - contentVerticalOffset;
    if (contentRef && contentRef.current) {
      contentRef.current.style.left = `${left}px`;
      contentRef.current.style.top = `${top}px`;
      contentRef.current.style.visibility = `visible`;
    }
  }, [containerRef, isVisible]);

  return (
    <div className={styles.tableActions} ref={containerRef}>
      <MoreIcon
        className={styles.moreIcon}
        onClick={(e) => setIsVisible(!isVisible)}
      />
      <If test={isVisible}>
        <AscPortal>
          <div ref={contentRef} className={styles.actionWrapper}>
            <AscAdminAction options={actions} className={styles.action} />
          </div>
        </AscPortal>
      </If>
    </div>
  );
}
